import React from 'react';
import {useTranslation} from 'react-i18next';
import {
  IconArrowBack,
  Inline,
  Text,
  useDevice,
  VisuallyHidden,
} from '@treatwell/ui';
import styles from './BackButton.module.css';
import {selectChannelData} from '../../store/slices/channel/slice';
import {useAppSelector} from '../../hooks/store';
import {trackEvent} from '../../utils/mParticleTracking';

type Props = {
  href: string;
  hideLabel?: boolean;
};

export const BackButton = ({href, hideLabel = false}: Props) => {
  const {t} = useTranslation();
  const label = t('calendar.navigateLink');
  const channel = useAppSelector(selectChannelData);
  const countryCode = channel.country.countryCode;
  const {isMobile} = useDevice();
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackEvent({
      eventName: 'back_button_clicked',
      eventAttributes: {
        country: countryCode,
        platform: 'web',
        is_web_mobile: isMobile,
        trigger_context: 'availability/back',
      },
    });
    window.location.href = e.currentTarget.href;
  };
  return (
    <a
      href={href}
      className={styles.backButton}
      data-cy="BackButton"
      onClick={onClick}
    >
      {hideLabel ? (
        <div className={styles.backButtonContainer}>
          <IconArrowBack size={24} />
          <VisuallyHidden>
            <Text>{label}</Text>
          </VisuallyHidden>
        </div>
      ) : (
        <Inline space="md">
          <IconArrowBack size={24} />
          <Text type="bodyHeavy">{label}</Text>
        </Inline>
      )}
    </a>
  );
};
